import { LocationOrderType } from 'features/Location/services/location'

export const checkLocationDetail = (
  locationDetail: LocationOrderType['location_detail'],
  filterLocationDetail: string[],
): boolean => filterLocationDetail.includes(locationDetail)
